import { useAnaliseLaboratorial } from "@/contexts/laboratorio/analiseLaboratorial/hooks/useAnaliseLaboratorial";
import { AnaliseLaboratorial } from "@/contexts/laboratorio/analiseLaboratorial/model/AnaliseLaboratorial";
import { useNetworkStatus } from "@/shared/hooks/useNetworkStatus";
import { formatMessageError } from "@/shared/utils/formatMessageError";
import { UploadOutlined } from "@ant-design/icons";
import { App, Button, Upload, UploadFile } from "antd";
import { RcFile, UploadChangeParam } from "antd/lib/upload";
import { useState } from "react";

export function SubmitBackupRequisicao() {
  const { isOnline } = useNetworkStatus();
  const { message, notification } = App.useApp();
  const { addRequisicao, submitRequisicaoApi } = useAnaliseLaboratorial();
  const [isLoading, setIsLoading] = useState(false);

  const lerArquivoTexto = (file: RcFile): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsText(file, "utf-8");
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });

  const dummyRequest = ({ file, onSuccess }: any) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const handleChangeUpload = async (
    info: UploadChangeParam<UploadFile<any>>
  ) => {
    setIsLoading(true);
    message.loading({
      content: "Processando backup...",
      key: "loading",
      duration: 0,
    });

    try {
      const conteudoTexto = await lerArquivoTexto(
        info.file.originFileObj as RcFile
      );

      // Validar se é JSON válido
      if (!conteudoTexto.trim().startsWith("{")) {
        throw new Error("Arquivo não contém JSON válido");
      }

      const jsonObject = JSON.parse(conteudoTexto) as AnaliseLaboratorial;

      // Validar estrutura básica
      if (!jsonObject.itens || !Array.isArray(jsonObject.itens)) {
        throw new Error("Estrutura do backup inválida");
      }

      const result = await submitRequisicaoApi(jsonObject);

      addRequisicao({
        ...jsonObject,
        id: result.id,
      });
      message.success({
        content: "Backup importado e requisição enviada com sucesso!",
        key: "loading",
      });

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      message.destroy("loading");
      console.error("Erro ao processar backup:", error);
      const messageError = formatMessageError(error);

      notification.error({
        message: "Erro ao processar backup",
        description: messageError,
        key: "loading",
      });
    }
  };

  return (
    <Upload
      customRequest={dummyRequest}
      onChange={handleChangeUpload}
      fileList={[]}
      accept="text/plain, .txt"
    >
      <Button disabled={!isOnline || isLoading} icon={<UploadOutlined />}>
        Enviar Backup
      </Button>
    </Upload>
  );
}
